/**
 * 日志过滤器.
 *
 * @author  yusangeng@outlook.com
 */
import config from "./config";
import { anything2Level } from "./levelHelper";
import Path from "./Path";
var assign = Object.assign;
/**
 * 日志级别,
 *
 * @enum {number}
 */
export var Level;
(function (Level) {
    Level[Level["DEBUG"] = 0] = "DEBUG";
    Level[Level["INFO"] = 1] = "INFO";
    Level[Level["WARN"] = 2] = "WARN";
    Level[Level["ERROR"] = 3] = "ERROR";
    Level[Level["MUTE"] = 4] = "MUTE";
    Level[Level["TEST"] = 9999] = "TEST";
})(Level || (Level = {}));
var Filter = /** @class */ (function () {
    function Filter(conf) {
        var myConf = assign({}, config, conf);
        this.level_ = anything2Level(myConf["chivy-level"]);
        this.modules_ = myConf["chivy-modules"].map(function (el) { return new Path(el); });
    }
    Filter.prototype.exec = function (level, moduleName) {
        return (this.level_ <= level && this.modules_.some(function (el) { return el.match(moduleName); }));
    };
    return Filter;
}());
export default Filter;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRmlsdGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL0ZpbHRlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7OztHQUlHO0FBR0gsT0FBTyxNQUF1QixNQUFNLFVBQVUsQ0FBQztBQUMvQyxPQUFPLEVBQUUsY0FBYyxFQUFFLE1BQU0sZUFBZSxDQUFDO0FBQy9DLE9BQU8sSUFBSSxNQUFNLFFBQVEsQ0FBQztBQUVsQixJQUFBLE1BQU0sR0FBSyxNQUFNLE9BQVgsQ0FBWTtBQUUxQjs7OztHQUlHO0FBQ0gsTUFBTSxDQUFOLElBQVksS0FPWDtBQVBELFdBQVksS0FBSztJQUNmLG1DQUFTLENBQUE7SUFDVCxpQ0FBUSxDQUFBO0lBQ1IsaUNBQVEsQ0FBQTtJQUNSLG1DQUFTLENBQUE7SUFDVCxpQ0FBUSxDQUFBO0lBQ1Isb0NBQVcsQ0FBQTtBQUNiLENBQUMsRUFQVyxLQUFLLEtBQUwsS0FBSyxRQU9oQjtBQXFCRDtJQUlFLGdCQUFZLElBQStCO1FBQ3pDLElBQU0sTUFBTSxHQUFHLE1BQU0sQ0FBQyxFQUFFLEVBQUUsTUFBTSxFQUFFLElBQUksQ0FBQyxDQUFDO1FBRXhDLElBQUksQ0FBQyxNQUFNLEdBQUcsY0FBYyxDQUFDLE1BQU0sQ0FBQyxhQUFhLENBQUMsQ0FBQyxDQUFDO1FBQ3BELElBQUksQ0FBQyxRQUFRLEdBQUcsTUFBTSxDQUFDLGVBQWUsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxVQUFDLEVBQVUsSUFBSyxPQUFBLElBQUksSUFBSSxDQUFDLEVBQUUsQ0FBQyxFQUFaLENBQVksQ0FBQyxDQUFDO0lBQzVFLENBQUM7SUFFRCxxQkFBSSxHQUFKLFVBQUssS0FBWSxFQUFFLFVBQWdCO1FBQ2pDLE9BQU8sQ0FDTCxJQUFJLENBQUMsTUFBTSxJQUFJLEtBQUssSUFBSSxJQUFJLENBQUMsUUFBUSxDQUFDLElBQUksQ0FBQyxVQUFBLEVBQUUsSUFBSSxPQUFBLEVBQUUsQ0FBQyxLQUFLLENBQUMsVUFBVSxDQUFDLEVBQXBCLENBQW9CLENBQUMsQ0FDdkUsQ0FBQztJQUNKLENBQUM7SUFDSCxhQUFDO0FBQUQsQ0FBQyxBQWhCRCxJQWdCQyJ9